export const RESPONSE_SURVEY_ENDPOINTS = {
  SUBMIT_RESPONSE: "/survey-manager/response-survey",
  LIST: "/survey-manager/survey-response/list",
  GETSURVEYRESONSEBYID: (id) => `/survey-manager/survey-response/${id}`,
  UPDATE: (id) => `/survey-manager/survey-response/${id}`,
  UPLOAD_ATTACHMENT: (companyId) =>
    `/files/upload/batch/${companyId}?subfolder=surveys-responses`,
  DELETE_ATTACHMENT: (fileId) => `/files/${fileId}`,
};
